// @flow

export const MODEL = 'Users'

// Api End Point
export const URL = '/client/'

// Status
export const ACTIVE = 'ACTIVE'
export const IN_ACTIVE = 'INACTIVE'

// Roles
export const ROLE_STAFF = 'Staff'
export const ROLE_GROWER = 'Grower'
export const ROLE_SUPERUSER = 'Superuser'
export const ROLE_ELVYRA_TECH = 'Elvyra Tech'

// Model Properties
export const PROP_ID = 'id'
export const PROP_USER_ID = PROP_ID
export const PROP_USERNAME = 'username'
export const PROP_FIRST = 'first'
export const PROP_LAST = 'last'
export const PROP_ROLES = 'roles'
export const PROP_STATUS = 'status'
export const PROP_PARENT = 'parent'
export const PROP_UNITS = 'units'
export const PROP_PHONE = 'phone'
export const PROP_CONTACTS = 'contacts'
export const PROP_USER_EMAIL = 'email'
export const PROP_USER = 'user'

// Contact types
export const PROP_CONTACT_TYPE_PHONE = 'Phone'
export const PROP_CONTACT_TYPE_EMAIL = 'Email'

// Unit Choices
export const PROP_US_CUSTOMARY = 'US CUSTOMARY'
export const PROP_METRIC = 'metric'
/* This defines the realm schema used by the mobile team for
    offline data storage. If you have questions please ask anyone
    on the mobile team.
  Valid types are:
  string: a string
  int: any non-floating point number
  float: any floating point number
  double: a double precision floating point number
  bool: a javascript boolean
  data: if you are unfamiliar with realm don't use this
  date: maps to javascript Date
*/
export const SCHEMA = [{
  name: MODEL,
  primaryKey: PROP_ID,
  properties: {
    id: {type: 'int'},
    username: {type: 'string'},
    first: {type: 'string', optional: true},
    last: {type: 'string', optional: true},
    status: {type: 'string', optional: true},
    roles: {type: 'string', optional: true},
    parent: {type: 'int', optional: true},
    units: {type: 'string', optional: true},
  },
}]
